import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitInquiry(payload) {
  const { data } = await api.post("/inquiries", payload);
  return data;
}

export async function adminLogin(password) {
  const { data } = await api.post("/admin/login", { password });
  return data;
}

export async function fetchInquiries(password) {
  const { data } = await api.get("/admin/inquiries", {
    headers: { "X-Admin-Password": password },
  });
  return data;
}

export function exportInquiriesUrl() {
  return `${API}/admin/inquiries/export`;
}

export async function deleteInquiries(password, ids) {
  const { data } = await api.post(
    "/admin/inquiries/delete",
    { ids },
    { headers: { "X-Admin-Password": password } }
  );
  return data;
}

// ---------- Press Articles ----------
export async function fetchPressArticles() {
  const { data } = await api.get("/press-articles");
  return data;
}

export async function fetchAdminPressArticles(password) {
  const { data } = await api.get("/admin/press-articles", {
    headers: { "X-Admin-Password": password },
  });
  return data;
}

export async function createPressArticle(password, article) {
  const { data } = await api.post("/admin/press-articles", article, {
    headers: { "X-Admin-Password": password },
  });
  return data;
}

export async function updatePressArticle(password, id, article) {
  const { data } = await api.put(`/admin/press-articles/${id}`, article, {
    headers: { "X-Admin-Password": password },
  });
  return data;
}

export async function deletePressArticle(password, id) {
  const { data } = await api.delete(`/admin/press-articles/${id}`, {
    headers: { "X-Admin-Password": password },
  });
  return data;
}

export async function reorderPressArticles(password, ids) {
  const { data } = await api.post(
    "/admin/press-articles/reorder",
    { ids },
    { headers: { "X-Admin-Password": password } }
  );
  return data;
}

export async function uploadPressImage(password, file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/admin/press-articles/upload-image", form, {
    headers: {
      "X-Admin-Password": password,
      "Content-Type": "multipart/form-data",
    },
  });
  return data.url;
}
